<template>
<div class="contain" >
      <div class="row m-0 p-0">
      <div class="col-sm-12 col-xs-12 col-lg-12 col-md-12  " style="margin-top:90px;">
         <div class="skill_para" >
                  <h1 class="skill_text">Skills</h1>
                  
                  <div class="skill_p"> 
                      <h5 class="wonder_text">Just my awesome skills 🤘</h5>
                  </div>
                </div>

           <div class="row mt-4 p-0 no-gutters">
            <div class="col-sm-12 col-xs-12 col-lg-6 col-md-12 " style="margin-bottom:0px;"  >
                  <div class="first_skill">
                 <div class="skill">
          <div class="skill-name mar-skill">Angular</div>
          <div class="skill-bar">
            <div class="skill-per" per="80"></div>
          </div>
        </div>

         <div class="skill">
          <div class="skill-name">Vue.js</div>
          <div class="skill-bar">
            <div class="skill-per" per="90"></div>
          </div>
        </div>

         <div class="skill">
          <div class="skill-name">HTML</div>
          <div class="skill-bar">
            <div class="skill-per" per="95"></div>
          </div>
        </div>

        <div class="skill">
          <div class="skill-name">CSS</div>
          <div class="skill-bar">
            <div class="skill-per" per="95"></div>
          </div>
          </div>
        </div>
            </div>
            <div class="col-sm-12 col-xs-12 col-lg-6 col-md-12 " style="margin-bottom:0px;margin-right:0px;" >
              
              <div class="skill">
          <div class="skill-name">React</div>
          <div class="skill-bar">
            <div class="skill-per" per="80"></div>
          </div>
        </div>

         <div class="skill">
          <div class="skill-name">Node.js</div>
          <div class="skill-bar">
            <div class="skill-per" per="80"></div>
          </div>
        </div>

         <div class="skill">
          <div class="skill-name">MongoDb</div>
          <div class="skill-bar">
            <div class="skill-per" per="80"></div>
          </div>
        </div>

        <div class="skill">
          <div class="skill-name">Bootstrap</div>
          <div class="skill-bar">
            <div class="skill-per" per="95"></div>
          </div>
          </div>

              </div>


            </div>
      </div>
      </div>
    </div>


</template>
<script>


jQuery(document).ready(function($) {
$(window).scroll(testScroll);
var viewed = false;

function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

function testScroll() {
  if (isScrolledIntoView($(".skill-per")) && !viewed) {
      viewed = true;
      $('.skill-per').each(function(){
    
           var $this = $(this);
           
            var per = $this.attr('per');
            console.log(per)
            $this.css("width",per + "%");
            $({animatedValue:0}).prop('counter',1).animate({animatedValue:per},{
              duration:1000,
               easing: 'swing',
              step:function(){
             $this.attr('per',Math.floor(this.animatedValue)+"%")
             },
             complete:function(){
          $this.attr('per',Math.floor(this.animatedValue)+'%')
           }
          });
 
         })





  }
}
  

})
    
      


       
</script>
<style scoped>
.contain{
    margin-left:70px;
    margin-right:80px;
    
    margin-bottom:50px;
   
        box-sizing: border-box;
}
.skill_text{
   
    position:relative;
    color:white;
    margin-left:0px;
    font-family: 'Merriweather Sans', sans-serif;  
}
.skill_text:after{
    position:absolute;
    content:"";
    display:block;
    height:0.5px;
    width:calc(100% - 119px);
     top:60%;
      left:119px;
    background:#FF033E;
}
.skill_p{
    color:white;
    font-size:17px;
     font-family: 'Source Sans Pro', sans-serif;
      letter-spacing:0.5px;
      position:relative;
     text-align:justify;
     font-weight:500;
}
.wonder_text{
    color:#00CED1;
    font-size:16px;
    margin-top:-10px;
  font-family: 'Source Sans Pro', sans-serif;
    margin-left:0px;
     font-weight:600;
  letter-spacing:1px;
}
.first_skill{
  width:94%;
}

.skill-name{
  font-size:17px;
  font-weight:700;
  color:white;
  
  margin:20px 0;
  font-family:'Merriweather Sans', sans-serif;
}
.skill-bar{
  height:6px;
  background:	#DCDCDC;
  border-radius:8px;
  box-shadow:0 0 0px #FF033E;
}
.skill-per{
  height:6px;
  background-color:#FF033E;
  border-radius:8px;
  width:0%;
  transition: 1s linear;
  position: relative;
  color:white;

}
.skill-per::before{
  content:attr(per);
  position:absolute;
  padding:4px 6px;
  background-color:#002244;
  font-size:12px;
  font-weight:700;
  border-radius:4px;
  top:-35px;
  right:0;
  transform:translateX(50%)
}
.skill-per::after{
  content:"";
  position:absolute;
  width:10px;
  height:10px;
  background-color:#002244;
  top:-16px;
  right:0;
  transform:translate(2px);
  border-radius:2px;


}
@media screen and (max-width: 567px)  {

.contain{
   margin-left:10px;
    margin-right:10px!important; 
    
}
.first_skill{
  width:100%;
}

}
@media screen and (min-width:1400px){

.contain{
   margin-left:100px;
    margin-right:100px;
}

}
@media screen and (min-width: 768px)and (max-width:1000px){
  .contain{
     margin-left:50px;
    margin-right:50px;
  }
  .first_skill{
  width:100%;
}

}
@media screen and (min-width: 568px) and (max-width: 767px)  {
     .contain{
    margin-left:30px;
    margin-right:30px!important;
    
    margin-bottom:50px;
    
}
.first_skill{
  width:100%;
}
}

</style>


